<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol :size="12">
        <MetaSection class="relative">
          <ThreeDotsMenu v-if="chartData">
            <template v-slot:trigger>
              <ArgonButton
                class="d-flex gap-1 align-items-center"
                type="button"
              >
                Export&nbsp;
                <span>
                  <i
                    class="fas fa-chevron-down cursor-pointer"
                    aria-hidden="true"
                  ></i>
                </span>
              </ArgonButton>
            </template>
            <button
              type="button"
              class="text-secondary font-weight-bold text-xs border-0 bg-transparent"
              @click="convertToCSV"
            >
              Export ke CSV
            </button>
            <button
              type="button"
              class="text-secondary font-weight-bold text-xs border-0 bg-transparent"
              @click="printPage"
            >
              Export ke PDF
            </button>
          </ThreeDotsMenu>
        </MetaSection>
      </GridCol>

      <GridCol :size="12" class="pb-4">
        <div class="d-flex align-items-center justify-content-start gap-2">
          <div class="d-flex justify-content-start w-100 gap-2">
            <FormGroup class="m-0 filter">
              <model-list-select
                class="form-control"
                v-model="params.unitkerja_id"
                :list="unitkerja.sort((a, b) => a.name.localeCompare(b.name))"
                option-value="id"
                option-text="name"
                placeholder="Pilih Unit Kerja"
              />
            </FormGroup>

            <FormGroup class="m-0 filter">
              <model-list-select
                class="form-control"
                v-model="params.periode_id"
                :list="
                  list_periode.sort((a, b) => a.name.localeCompare(b.name))
                "
                option-value="id"
                option-text="name"
                placeholder="Pilih Periode"
              />
            </FormGroup>
          </div>
        </div>
      </GridCol>

      <GridCol :size="12">
        <CardComponent :useHeader="true" :withmin="false">
          <!-- <template v-slot:header-action>
            header
          </template> -->

          <div
            class="d-flex justify-content-center text-center border py-10"
            v-if="!showData"
          >
            <h5>Pilih Unit Kerja dan Periode Terlebih Dahulu</h5>
          </div>

          <div v-else id="print-section" ref="printSection">
            <div class="title-print text-center pb-4 visually-hidden">
              <h3>Laporan Kurva Normal Pegawai</h3>
              <h2>Unit Kerja {{ unitkerja?.filter(item => item.id === params.unitkerja_id)?.[0]?.name || '-' }} - Periode {{ list_periode?.filter(item => item.id === params.periode_id)?.[0]?.name || '-' }}</h2>
            </div>

            <div class="d-flex flex-column gap-5">
              <div class="d-flex flex-column">
                <div class="mb-2 d-flex items-center justify-content-between">
                  <h5>Kurva Distribusi Normal</h5>
                </div>

                <canvas
                  ref="chartCanvas"
                  style="max-height: 550px"
                  class="border p-4 rounded-2"
                ></canvas>
              </div>

              <div class="row">
                <div class="col">
                  <div>
                    <div class="mb-3 d-flex items-center justify-content-between">
                      <h5>Rekap Yudisium Penilaian</h5>
                    </div>

                    <div class="row gap-3" style="padding: 12px">
                      <div
                        class="col border rounded-2 p-3 d-flex flex-column gap-2 w-100 align-items-start justify-content-between"
                        style="min-height: 197px;"
                      >
                        <span>Memuaskan</span>
                        <span class="fs-1 fw-bold">{{
                          chartData?.summary?.count_memuaskan || '0'
                        }}</span>
                        <span style="font-size: 12px"></span>
                      </div>
                      <div
                        class="col border rounded-2 p-3 d-flex flex-column gap-2 w-100 align-items-start justify-content-between"
                        style="min-height: 197px;"
                      >
                        <span>Baik</span>
                        <span class="fs-1 fw-bold">{{
                          chartData?.summary?.count_baik || '0'
                        }}</span>
                        <span style="font-size: 12px"></span>
                      </div>
                      <div
                        class="col border rounded-2 p-3 d-flex flex-column gap-2 w-100 align-items-start justify-content-between"
                        style="min-height: 197px;"
                      >
                        <span>Cukup</span>
                        <span class="fs-1 fw-bold">{{
                          chartData?.summary?.count_cukup || '0'
                        }}</span>
                        <span style="font-size: 12px"></span>
                      </div>
                      <div
                        class="col border rounded-2 p-3 d-flex flex-column gap-2 w-100 align-items-start justify-content-between"
                        style="min-height: 197px;"
                      >
                        <span>Kurang</span>
                        <span class="fs-1 fw-bold">{{
                          chartData?.summary?.count_kurang || '0'
                        }}</span>
                        <span style="font-size: 12px"></span>
                      </div>
                    </div>
    
                    <div class="chart-wrapper border p-4 rounded-2 w-100">
                      <canvas ref="chartDonut" id="chart-donut-canvas" />
                    </div>
                  </div>
                </div>
                
                <div class="col">
                  <div>
                    <div class="mb-2 d-flex items-center justify-content-between">
                      <h5>Ringkasan Penilaian Kinerja</h5>
    
                      <!-- <span>Ubah</span> -->
                      <!-- <span class="btn btn-primary">Ubah</span> -->
                      <ArgonButton
                        outline
                        class="btn-link border-0 no-print"
                        databstoggle="modal"
                        databstarget="#exampleModal"
                        >Ubah</ArgonButton
                      >
                    </div>
    
                    <div class="row gap-3" style="padding: 12px">
                      <div
                        class="col border rounded-2 p-3 d-flex flex-column gap-2 w-100 align-items-start justify-content-between"
                        style="min-height: 197px;"
                      >
                        <span>Nilai KPI Unit</span>
                        <span class="fs-1 fw-bold">{{
                          chartData?.summary?.nilai_keselarasan || "-"
                        }}</span>
                        <span style="font-size: 12px">{{ chartData?.summary?.penyesuaian === true ? 'Sudah ada penyesuaian' : 'Belum ada penyesuaian'}}</span>
                      </div>
                      <div
                        class="col border rounded-2 p-3 d-flex flex-column gap-2 w-100 align-items-start justify-content-between"
                        style="min-height: 197px;"
                      >
                        <span>Nilai Rata-rata Kinerja Individu</span>
                        <span class="fs-1 fw-bold">{{
                          chartData?.summary?.avg_keselarasan || "-"
                        }}</span>
                        <span style="font-size: 12px">{{ chartData?.summary?.penyesuaian === true ? 'Sudah ada penyesuaian' : 'Belum ada penyesuaian'}}</span>
                      </div>
                      <div
                        class="col border rounded-2 p-3 d-flex flex-column gap-2 w-100 align-items-start justify-content-between"
                        style="min-height: 197px;"
                      >
                        <span>Kesesuaian KPI</span>
                        <span class="fs-1 fw-bold">{{
                          chartData?.summary?.percentage
                            ? `${chartData?.summary?.percentage}%`
                            : "-"
                        }}</span>
                        <span style="font-size: 12px"
                          >Tingkat keselarasan nilai KPI</span
                        >
                      </div>
                    </div>
    
                    <canvas
                      ref="chartBar"
                      style="height: 320px !important"
                      class="border p-4 rounded-2"
                    />
                  </div>
                </div>
              </div>

              <div id="table-section">
                <div class="mb-2 d-flex items-center justify-content-between">
                  <h5>Daftar Karyawan</h5>
                </div>

                <ListView
                  :thead="[
                    'No.',
                    'NIP',
                    'Nama',
                    'Unit Kerja',
                    'Jabatan',
                    'Nilai Kinerja',
                    'Nilai Kompetensi',
                    'Total Penugasan',
                    'Total Pengurangan',
                    'Nilai Akhir',
                    'Yudisium',
                    'Standar Z',
                    'Distribusi Normal',
                  ]"
                  class="table-limit"
                >
                  <template v-slot:tbody>
                    <!-- <tr v-if="data.length < 1">
                      <td colspan="7" class="text-center text-secondary">Tidak ada data</td>
                    </tr> -->
                    <!-- <tr v-for="(item, index) in data" :key="index">
                      <td>{{ item.nip || "-" }}</td>
                      <td class="font-weight-bold">{{ item.name || "-" }}</td> -->

                    <!-- <tr v-for="(item, index) in 10" :key="index">
                      <td>{{ item }}</td>
                      <td>Muhammad Satrio Nugroho</td>
                      <td>Pengelola</td>
                      <td>4.00</td>
                      <td>
                        <ArgonBadge color="warning" class="text-warning" v-if="item === 8 || item === 9">Cukup</ArgonBadge>
                        <ArgonBadge color="danger" v-else-if="item === 10">Kurang</ArgonBadge>
                        <ArgonBadge v-else>Baik</ArgonBadge>
                      </td>
                      <td>1.24</td>
                      <td>0.6</td>
                    </tr> -->

                    <tr v-if="!chartData?.data || chartData?.data?.length < 1">
                      <td colspan="13" class="text-center text-secondary">
                        Tidak ada data
                      </td>
                    </tr>

                    <tr v-for="(item, index) in chartData?.data" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item?.nip || "-" }}</td>
                      <td>{{ item?.name || "-" }}</td>
                      <td class="text-wrap">
                        {{ item?.unitkerja || "-" }}
                      </td>
                      <td width="500" class="text-wrap">
                        {{ item?.jabatan || "-" }}
                      </td>
                      <td>{{ item?.nilai_kinerja || item?.nilai_kinerja === 0 ? item?.nilai_kinerja : "-" }}</td>
                      <td>{{ item?.nilai_kompetensi || item?.nilai_kompetensi === 0 ? item?.nilai_kompetensi : "-" }}</td>
                      <td>{{ item?.total_penugasan || item?.total_penugasan === 0 ? item?.total_penugasan : "-" }}</td>
                      <td>{{ item?.total_pengurangan || item?.total_pengurangan === 0 ? item?.total_pengurangan : "-" }}</td>
                      <td>{{ item?.nilai_akhir || item?.nilai_akhir === 0 ? item?.nilai_akhir : "-" }}</td>
                      <td>
                        <ArgonBadge
                          v-if="
                            item?.indeks_penilaian_akhir?.toLocaleLowerCase() === 'a'
                          "
                          >{{ item?.indeks_penilaian_akhir }}</ArgonBadge
                        >
                        <ArgonBadge
                          v-else-if="
                            item?.indeks_penilaian_akhir?.toLocaleLowerCase() === 'b'
                          "
                          color="info"
                          >{{ item?.indeks_penilaian_akhir }}</ArgonBadge
                        >
                        <ArgonBadge
                          color="warning"
                          class="text-warning"
                          v-else-if="
                            item?.indeks_penilaian_akhir?.toLocaleLowerCase() === 'c'
                          "
                          >{{ item?.indeks_penilaian_akhir }}</ArgonBadge
                        >
                        <ArgonBadge color="danger" v-else>{{
                          item?.indeks_penilaian_akhir
                        }}</ArgonBadge>
                      </td>
                      <td>{{ item?.z_score || item?.z_score === 0 ? item?.z_score : "-" }}</td>
                      <td>{{ item?.normal_distribution || item?.normal_distribution === 0 ? item?.normal_distribution : "-" }}</td>
                    </tr>
                  </template>
                </ListView>
              </div>
            </div>

            <div class="result">
              <div
                class="result-value d-flex align-items-center justify-content-between border-b border-primary"
              >
                <span>Nilai Rata-rata</span>
                <strong>{{ chartData?.summary?.avg || "-" }}</strong>
              </div>
              <div
                class="result-value d-flex align-items-center justify-content-between border-b border-primary"
              >
                <span>Standar Deviasi</span>
                <strong>{{ chartData?.summary?.stddev || "-" }}</strong>
              </div>
            </div>

            <!-- </template> -->
          </div>
        </CardComponent>
      </GridCol>
    </GridRow>

    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form @submit.prevent="saveModal()">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Ubah Nilai Kinerja
              </h5>
              <button
                type="button"
                class="btn-close"
                style="color: #000"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <font-awesome-icon icon="fa-solid fa-xmark" />
              </button>
            </div>
            <div class="modal-body">
              <div class="d-flex flex-column gap-4">
                <FormGroup label="Nilai KPI" class="mb-0">
                  <!-- <input type="text" @keyup="setSubSlug()" name="sub-title" id="sub-title" class="form-control" v-model="sub.title"> -->
                  <input
                    type="number"
                    name="sub-title"
                    id="sub-title"
                    class="form-control"
                    v-model="model.nilai"
                    min="0"
                    step="0.01"
                    required
                    placeholder="Masukkan nilai"
                  />
                  <p class="pt-2 m-0" style="font-size: 14px">
                    Nilai awal
                    {{ chartData?.summary?.nilai_keselarasan || "-" }}
                  </p>
                </FormGroup>
                <FormGroup
                  label="Nilai Rata-rata Kinerja Individu"
                  class="mb-0"
                >
                  <input
                    type="number"
                    name="sub-description"
                    id="sub-description"
                    class="form-control"
                    v-model="model.rata_rata"
                    min="0"
                    step="0.01"
                    required
                    placeholder="Masukkan rata-rata"
                  />
                  <p class="pt-2 m-0" style="font-size: 14px">
                    Nilai awal {{ chartData?.summary?.avg_keselarasan || "-" }}
                  </p>
                </FormGroup>
              </div>
            </div>
            <div class="modal-footer">
              <div class="w-100 d-flex align-items-center gap-2">
                <!-- <ArgonButton type="button" databsdismiss="modal" outline class="w-100" ref="closeModalKoreksi">Batalkan</ArgonButton> -->
                <!-- <ArgonButton type="submit" class="w-100">Simpan</ArgonButton> -->
                <button
                  type="button"
                  class="btn btn-outline-secondary w-100"
                  data-bs-dismiss="modal"
                  ref="closeModalKoreksi"
                >
                  Batalkan
                </button>
                <button type="submit" class="btn btn-primary w-100">
                  Simpan
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardComponent from "@/components/CardComponent.vue";
// import InputGroup from '@/components/InputGroup.vue';
// import LaporanSummaryApi from '@/repository/api/LaporanSummaryApi';
import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";
import UnitKerjaApi from "@/repository/api/UnitKerjaApi";
import LaporanKurvaNormalApi from "@/repository/api/LaporanKurvaNormalApi";
import MetaSection from "@/components/MetaSection.vue";
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import ListView from "@/components/ListView.vue";
import FormGroup from "@/components/FormGroup.vue";
// import ArgonPagination from '@/components/ArgonPagination.vue';
import ArgonBadge from "@/components/ArgonBadge.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
// import FieldsetComponent from "@/views/components/FieldsetComponent.vue";
import Chart from "chart.js/auto";
import ThreeDotsMenu from "@/components/ThreeDotsMenu.vue";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default {
  name: "tables",
  components: {
    CardComponent,
    // InputGroup,
    MetaSection,
    GridRow,
    GridCol,
    ListView,
    FormGroup,
    // ArgonPagination,
    ArgonBadge,
    ArgonButton,
    ModelListSelect,
    // FieldsetComponent,
    ThreeDotsMenu,
  },
  data() {
    return {
      moment,
      // timer: undefined,
      // data: [],
      list_periode: [],
      unitkerja: [],

      params: {
        periode_id: "",
        unitkerja_id: "",
        page: "all",
      },

      model: {
        nilai: "",
        rata_rata: "",
      },

      chartInstance: null,
      chartDonutInstance: null,
      chartBarInstance: null,

      showData: false,
      chartData: null,
    };
  },
  watch: {
    params: {
      handler(newValue) {
        if (newValue.periode_id && newValue.unitkerja_id) this.getChartData();
      },
      deep: true,
    },
  },
  methods: {
    async printPage() {
      const printEl = this.$refs.printSection;
      if (!printEl) return;

      const tableLimit = printEl.querySelector(".table-limit");
      let originalMaxHeight;

      if (tableLimit) {
        originalMaxHeight = tableLimit.style.maxHeight;
        tableLimit.style.maxHeight = "unset";
        tableLimit.style.overflow = "visible";
      }

      await this.$nextTick();

      const pdf = new jsPDF("p", "mm", "a4");
      const margin = 15;
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const usableWidth = pageWidth - margin * 2;
      const usableHeight = pageHeight - margin * 2;

      // HALAMAN 1: SEMUA CHART (3 chart)
      const chartCanvas = this.$refs.chartCanvas;
      const chartDonut = this.$refs.chartDonut;
      const chartBar = this.$refs.chartBar;

      const chartNormalCanvas = await html2canvas(chartCanvas.parentElement, {
        scale: 1.5,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
      });
      const chartDonutCanvas = await html2canvas(
        chartDonut.parentElement.parentElement,
        {
          scale: 1.5,
          useCORS: true,
          logging: false,
          backgroundColor: "#ffffff",
        }
      );
      const chartBarCanvas = await html2canvas(chartBar.parentElement, {
        scale: 1.5,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
      });

      const chartNormalImg = chartNormalCanvas.toDataURL("image/jpeg", 0.85);
      const chartDonutImg = chartDonutCanvas.toDataURL("image/jpeg", 0.85);
      const chartBarImg = chartBarCanvas.toDataURL("image/jpeg", 0.85);

      let currentY = margin;

      // title section
      const titleSection = printEl.querySelector(".title-print");
      const clonedTitle = titleSection.cloneNode(true);
      clonedTitle.classList.remove("visually-hidden");

      // Render clonedTitle into canvas
      const titleContainer = document.createElement("div");
      titleContainer.style.background = "#ffffff";
      titleContainer.appendChild(clonedTitle);
      document.body.appendChild(titleContainer);

      const titleCanvas = await html2canvas(titleContainer, {
        scale: 1.5,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
      });

      document.body.removeChild(titleContainer);

      const titleImg = titleCanvas.toDataURL("image/jpeg", 0.85);
      const titleHeight =
        (titleCanvas.height * usableWidth) / titleCanvas.width;

      // Add title before chart
      pdf.addImage(titleImg, "JPEG", margin, currentY, usableWidth, titleHeight);
      currentY += titleHeight + 10;

      // Chart 1: Normal Distribution
      const chartNormalHeight =
        (chartNormalCanvas.height * usableWidth) / chartNormalCanvas.width;
      if (currentY + chartNormalHeight > pageHeight - margin) {
        pdf.addPage();
        currentY = margin;
      }
      pdf.addImage(
        chartNormalImg,
        "JPEG",
        margin,
        currentY,
        usableWidth,
        chartNormalHeight
      );
      currentY += chartNormalHeight + 8;

      // Chart 2: Donut
      const chartDonutHeight =
        (chartDonutCanvas.height * usableWidth) / chartDonutCanvas.width;
      if (currentY + chartDonutHeight > pageHeight - margin) {
        pdf.addPage();
        currentY = margin;
      }
      pdf.addImage(
        chartDonutImg,
        "JPEG",
        margin,
        currentY,
        usableWidth,
        chartDonutHeight
      );
      currentY += chartDonutHeight + 8;

      // Chart 3: Bar (Ringkasan Penilaian)
      const chartBarHeight =
        (chartBarCanvas.height * usableWidth) / chartBarCanvas.width;
      if (currentY + chartBarHeight > pageHeight - margin) {
        pdf.addPage();
        currentY = margin;
      }
      pdf.addImage(
        chartBarImg,
        "JPEG",
        margin,
        currentY,
        usableWidth,
        chartBarHeight
      );

      // HALAMAN 2+: TABLE + RESULT (CHUNKED)
      const tableSection = printEl.querySelector(
        // ".d-flex.flex-column.gap-5 > div:nth-child(4)"
        ".d-flex.flex-column.gap-5 > div:nth-child(3)"
      );
      const resultSection = printEl.querySelector(".result");

      const tempContainer = document.createElement("div");
      tempContainer.style.padding = "20px";
      tempContainer.style.backgroundColor = "#ffffff";
      tempContainer.appendChild(tableSection.cloneNode(true));
      tempContainer.appendChild(resultSection.cloneNode(true));
      document.body.appendChild(tempContainer);

      const tableResultCanvas = await html2canvas(tempContainer, {
        scale: 1.5,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
      });

      document.body.removeChild(tempContainer);

      const imgWidth = usableWidth;
      const imgHeight =
        (tableResultCanvas.height * usableWidth) / tableResultCanvas.width;

      pdf.addPage();
      let yOffset = 0;
      let pageY = margin;

      while (yOffset < imgHeight) {
        const remainingHeight = imgHeight - yOffset;
        const heightToDraw = Math.min(remainingHeight, usableHeight);

        const sourceY = (yOffset / imgHeight) * tableResultCanvas.height;
        const sourceHeight =
          (heightToDraw / imgHeight) * tableResultCanvas.height;

        const croppedCanvas = document.createElement("canvas");
        croppedCanvas.width = tableResultCanvas.width;
        croppedCanvas.height = sourceHeight;

        const ctx = croppedCanvas.getContext("2d");
        ctx.drawImage(
          tableResultCanvas,
          0,
          sourceY,
          tableResultCanvas.width,
          sourceHeight,
          0,
          0,
          tableResultCanvas.width,
          sourceHeight
        );

        const croppedImg = croppedCanvas.toDataURL("image/jpeg", 0.85);
        pdf.addImage(croppedImg, "JPEG", margin, pageY, imgWidth, heightToDraw);

        yOffset += heightToDraw;

        if (yOffset < imgHeight) {
          pdf.addPage();
          pageY = margin;
        }
      }

      if (tableLimit) {
        tableLimit.style.maxHeight = originalMaxHeight;
        tableLimit.style.overflow = "auto";
      }

      pdf.save(`laporan_kurva_normal_pegawai_${this.moment().unix()}.pdf`);
    },
    convertToCSV() {
      const csvData = this.convertJSONToCSV(
        this.chartData?.data?.map((item) => {
          return {
            nip: item?.nip ?? "",
            name: item?.name ?? "",
            unit_kerja: item?.unitkerja ?? "",
            jabatan: item?.jabatan ?? "",
            nilai_kinerja: item?.nilai_kinerja ?? "",
            nilai_kompetensi: item?.nilai_kompetensi ?? "",
            total_penugasan: item?.total_penugasan ?? "",
            total_pengurangan: item?.total_pengurangan ?? "",
            nilai_akhir: item?.nilai_akhir ?? "",
            yudisium: item?.indeks_penilaian_akhir ?? "",
            z_score: item?.z_score ?? "",
            normal_distribution: item?.normal_distribution ?? "",
          };
        })
      );
      this.downloadCSV(
        csvData,
        `laporan_kurva_normal_pegawai_${this.moment().unix()}.csv`
      );
    },
    convertJSONToCSV(jsonData) {
      const headers = Object.keys(jsonData[0]);
      const csvRows = [];

      csvRows.push(headers.join(","));

      jsonData.forEach((row) => {
        const values = headers.map((header) => {
          const value = row[header];
          return JSON.stringify(value);
        });
        csvRows.push(values.join(","));
      });

      return csvRows.join("\n");
    },
    downloadCSV(csvData, filename) {
      const blob = new Blob([csvData], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    async getChartData() {
      this.$store.state.loading = true;
      this.chartData = null;
      this.showData = false;

      await LaporanKurvaNormalApi.getKurvaNormalPegawai(this.params)
        .then((response) => {
          this.showData = true;

          this.chartData = response?.data || null;
          setTimeout(() => {
            this.createChart();
            this.createChartDonut();
            this.createChartBar();
          }, 50);
        })
        .catch(() => {
          // this.list_periode = [];
          this.showData = false;
          this.chartData = null;
        });
      this.$store.state.loading = false;
    },
    async getPeriode() {
      await KpiPeriodeApi.getbyparam({ page: "all", status: "active" })
        .then((response) => {
          this.list_periode = response?.data;
          // this.params.periode_id = this.list_periode?.[0]?.id || '';
        })
        .catch(() => {
          this.list_periode = [];
        });
    },
    async getUnitKerja() {
      this.$store.state.loading = true;
      await UnitKerjaApi.getbyparam({ page: "all", status: "active" })
        .then((response) => {
          this.unitkerja = response.data;
        })
        .catch(() => {
          this.unitkerja = [];
        });
      this.$store.state.loading = false;
    },

    // Gaussian (Normal Distribution) Function
    gaussian(x, mean = 0, sigma = 0.5) {
      const coeff = 1 / (sigma * Math.sqrt(2 * Math.PI));
      const exponent = -((x - mean) ** 2) / (2 * sigma ** 2);
      return coeff * Math.exp(exponent);
    },

    createChart() {
      // const xValues = []
      // const yValues = []

      // // Generate data points between -2 and 2
      // for (let x = -2; x <= 2; x += 0.25) {
      //   xValues.push(x.toFixed(2))
      //   yValues.push(this.gaussian(x))
      // }

      const normal_dist_data =
        this.chartData?.chart_data?.normal_distribution || [];

      // const xValues = this.chartData?.chart_data?.z_score?.reverse() || [];
      const rawX = this.chartData?.chart_data?.z_score?.reverse() || [];
      const xValues = rawX.map(v => Number(v));  // IMPORTANT: convert to number
      // const xValues = normal_dist_data.map((_, i) => `P${i + 1}`)
      const yValues = normal_dist_data;

      // const dataY = yValues.map(d => d.y);
      // const maxY = Math.max(...yValues);

      const ctx = this.$refs.chartCanvas.getContext("2d");

      // const boldYAxisPlugin = {
      //   id: "boldYAxisPlugin",
      //   afterDraw(chart) {
      //     const { ctx, chartArea, scales } = chart;
      //     const zeroX = scales.x.getPixelForValue(0);

      //     ctx.save();
      //     ctx.beginPath();
      //     ctx.moveTo(zeroX, chartArea.top);
      //     ctx.lineTo(zeroX, chartArea.bottom);
      //     ctx.lineWidth = 3.5;             // <--- make it bold here
      //     // ctx.strokeStyle = "#000000";   // <--- color of the Y axis
      //     ctx.stroke();
      //     ctx.restore();
      //   }
      // }

      this.chartInstance = new Chart(ctx, {
        type: "line",
        data: {
          labels: xValues,
          datasets: [
            {
              label: "Normal Distribution",
              data: yValues,
              borderColor: "rgba(54, 162, 235, 1)",
              borderWidth: 2,

              tension: 0.4, // Smooth curve
              cubicInterpolationMode: "monotone",

              pointBackgroundColor: "red",
              pointBorderColor: "red",
              pointRadius: 5,
              // pointRadius: 0,          // ganti ke 0 jika mau super smooth tanpa titik
              pointHoverRadius: 6,

              fill: false,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: true,
              callbacks: {
                label: (context) => `y: ${context.parsed.y.toFixed(3)}`,
              },
            },
          },
          scales: {
            x: {
              title: { display: false },
              ticks: {
                callback: function (val, index) {
                  return xValues[index];
                },
              },
            },
            y: {
              beginAtZero: true,
              title: { display: false },
              position: 'center',     // <--- taruh Y-axis di tengah canvas
            },
          },
        },
        // plugins: [boldYAxisPlugin],   // <--- added plugin 
      });
    },

    // ----------------

    // createChart() {
    //   const normal_dist_data =
    //     this.chartData?.chart_data?.normal_distribution || [];

    //   // Reverse & convert to numeric
    //   const rawX = this.chartData?.chart_data?.z_score?.reverse() || [];
    //   const xValues = rawX.map(v => Number(v));  // IMPORTANT: convert to number
    //   const yValues = normal_dist_data;

    //   const ctx = this.$refs.chartCanvas.getContext("2d");

    //   // 🔥 Custom plugin to draw bold Y-axis at x = 0
    //   const boldYAxisPlugin = {
    //     id: "boldYAxisPlugin",
    //     afterDraw(chart) {
    //       const { ctx, chartArea, scales } = chart;

    //       // get pixel position of x = 0
    //       const zeroX = scales.x.getPixelForValue(0);

    //       ctx.save();
    //       ctx.beginPath();
    //       ctx.moveTo(zeroX, chartArea.top);
    //       ctx.lineTo(zeroX, chartArea.bottom);
    //       ctx.lineWidth = 4;   // bold thickness
    //       ctx.strokeStyle = "#000"; 
    //       ctx.stroke();
    //       ctx.restore();
    //     }
    //   };

    //   // 🔥 Build dataset with {x, y}
    //   const datasetXY = xValues.map((x, i) => ({
    //     x,
    //     y: yValues[i]
    //   }));

    //   this.chartInstance = new Chart(ctx, {
    //     type: "line",
    //     data: {
    //       datasets: [
    //         {
    //           label: "Normal Distribution",
    //           data: datasetXY,                // MUST BE XY objects
    //           borderColor: "rgba(54, 162, 235, 1)",
    //           borderWidth: 2,
    //           tension: 0.4,
    //           cubicInterpolationMode: "monotone",

    //           pointBackgroundColor: "red",
    //           pointBorderColor: "red",
    //           pointRadius: 5,
    //           pointHoverRadius: 6,
    //         },
    //       ],
    //     },

    //     options: {
    //       responsive: true,

    //       scales: {
    //         x: {
    //           type: "linear",     // 🔥 required for centered axis
    //           title: { display: false },
    //           ticks: {
    //             callback: v => v.toFixed(2),
    //           },
    //         },

    //         y: {
    //           beginAtZero: true,
    //           position: "center", // 🔥 center Y-axis visually (ticks/grid)
    //         },
    //       },

    //       plugins: {
    //         legend: { display: false },
    //         tooltip: {
    //           callbacks: {
    //             label: (ctx) => `y: ${ctx.parsed.y.toFixed(3)}`,
    //           },
    //         },
    //       },
    //     },

    //     plugins: [boldYAxisPlugin], // <--- bold centered Y-axis
    //   });
    // },

    createChartDonut() {
      const chart_data = [
        this.chartData?.summary?.count_memuaskan || 0,
        this.chartData?.summary?.count_baik || 0,
        this.chartData?.summary?.count_cukup || 0,
        this.chartData?.summary?.count_kurang || 0,
      ];

      const ctx = this.$refs.chartDonut.getContext("2d");

      this.chartDonutInstance = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: ["Memuaskan", "Baik", "Cukup", "Kurang"],
          datasets: [
            {
              // data: [7, 2, 1],
              data: chart_data,
              backgroundColor: ["#4CAF50", "#0385f3", "#F4B400", "#FF0000"], // green, yellow, red
              hoverOffset: 4,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false, // allow fixed height
          aspectRatio: 1, // keep chart circular (1:1)
          plugins: {
            legend: {
              display: false, // hide display
              position: "bottom",
              labels: {
                usePointStyle: true,
                generateLabels: (chart) => {
                  const { data } = chart;
                  return data.labels.map((label, i) => ({
                    text: `${label} ${data.datasets[0].data[i]}`,
                    fillStyle: data.datasets[0].backgroundColor[i],
                    strokeStyle: data.datasets[0].backgroundColor[i],
                    pointStyle: "circle",
                  }));
                },
              },
            },
            tooltip: {
              callbacks: {
                label: (context) => `${context.label}: ${context.parsed}`,
              },
            },
          },
          // cutout: '60%',
        },
      });
    },
    createChartBar() {
      const chart_data = [
        this.chartData?.summary?.nilai_keselarasan || 0,
        this.chartData?.summary?.avg_keselarasan || 0,
      ];
      const ctx = this.$refs.chartBar.getContext("2d");

      this.chartInstance = new Chart(ctx, {
        type: "bar",
        data: {
          labels: ["Nilai KPI Unit", "Nilai Rata-rata Kinerja Individu"],
          datasets: [
            {
              // data: [82, 88], // example values
              data: chart_data,
              backgroundColor: "#0385F3",
              borderRadius: 8,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: { display: false },
            tooltip: {
              callbacks: {
                label: (context) => `${context.parsed.y}`,
              },
            },
          },
          scales: {
            x: {
              grid: { display: false },
              ticks: { font: { size: 12 } },
            },
            y: {
              beginAtZero: true,
              grid: { color: "#eee" },
              ticks: { stepSize: 1 },
            },
          },
        },
      });
    },

    async saveModal() {
      this.$store.state.loading = true;

      const params = {
        ...this.params,
        ...this.model,
      };

      await LaporanKurvaNormalApi.koreksiKurvaNormalPegawai(params)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          });
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: error.response.data.message,
          });
        });

      this.model = {
        nilai: "",
        rata_rata: "",
      };

      this.$refs.closeModalKoreksi.click();
      this.getChartData();
      // this.$store.state.loading = false;
    },
  },
  async mounted() {
    // await this.getData();
    await this.getUnitKerja();
    await this.getPeriode();
  },

  beforeUnmount() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  },
};
</script>

<style>
.chart-wrapper {
  width: 350px; /* fixed width */
  height: 350px; /* fixed height (same as width to keep circle) */
  margin: 0 auto; /* center horizontally */
  display: flex;
  justify-content: center;
  align-items: center;
}

canvas {
  width: 100% !important;
  height: 100% !important;
}

.result {
  background: #d9eafe;
  color: #0385f3;
}
.result .result-value {
  padding: 8px 16px;
}
.result .result-value:nth-child(1) {
  border-bottom: 1px solid #c5e0fe !important;
}

.threedotsmenu-hover {
  width: fit-content !important;
  padding-right: 40px !important;
}

.table-limit {
  max-height: 740px;
  overflow-y: auto;
}

/* PRINT ONLY SPECIFIC AREA */
@media print {
  body * {
    visibility: hidden !important;
  }

  #print-section,
  #print-section * {
    visibility: visible !important;
  }

  .no-print {
    visibility: hidden !important;
  }

  #print-section {
    position: absolute !important;
    inset: 0 !important; /* Shorthand: top:0 left:0 right:0 bottom:0 */
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    height: auto !important;
    overflow: visible !important;
    box-sizing: border-box !important;

    /* position: absolute; */
    /* left: 0;
    top: 0; */
    /* width: 100% !important; */
    /* margin: 0 !important;
    padding: 0 !important; */

    /* FORCE 1 LONG PAGE */
    /* height: auto !important;
    overflow: visible !important; */
  }

  /* REMOVE ALL EXTRA SPACING BETWEEN BLOCKS */
  /* #print-section > * {
    margin: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    break-after: avoid !important;
    break-before: avoid !important;
  } */

  #print-section > * {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    break-before: avoid !important;
    break-after: avoid !important;
    break-inside: avoid !important;
  }

  /* PREVENT PAGE BREAK INSIDE EVERYTHING */
  #print-section,
  #print-section * {
    break-inside: avoid !important;
    page-break-inside: avoid !important;

    /* padding-top: 0 !important;
    margin: 0 !important; */
  }

  /* Fix for charts & canvas */
  /* canvas {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    display: block !important;
  } */

  canvas#chart-donut-canvas {
    width: 1450px !important;
    height: 280px !important;
  }

  /* Fix for tables */
  /* table {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    border-collapse: collapse !important;
  } */

  .table-limit {
    max-height: fit-content;
    overflow-y: auto;
    width: 100% !important;
  }

  /* Remove page margins */
  @page {
    size: A4 landscape;
    margin: 0 !important;
  }
}
</style>
